import { AddressJSON } from "_shared/addresses/address-schema";
import Guid from "_shared/guids/guid";
import Company from "marketplace/companies/company";
import CompanyProfile from "marketplace/companies/profiles/company-profile";
import Individual from "marketplace/individuals/individual";
import IndividualProfile from "marketplace/individuals/profiles/individual-profile";

export default class MarketplaceSubscriberInfoAPIResponse {
  public isVisible?: boolean;
  public userId?: string;
  public credentials?: string;
  public individualId?: string;
  public firstName?: string;
  public lastName?: string;
  public avatar?: string;
  public email?: string;
  public professionalRegistration?: string;
  public technicalBackgrounds?: string[];
  public practiceAreas?: string[];
  public location?: AddressJSON;
  public phoneNumber?: string;
  public school?: string;
  public resume?: string;
  public potentialDiversityCandidate?: boolean;
  public additionalInfo?: string;
  public fluentLanguages?: string[];
  public technicalLanguages?: string[];
  public regionsRegistered?: string[];
  public categories?: string[];
  public collaborates?: boolean;
  public companyId?: string;
  public legalEntityId?: string;
  public companyName?: string;
  /** Wrote in the forum and is no longer one of its participants (#6878). */
  public hasLeft?: boolean;

  public constructor(values: Partial<MarketplaceSubscriberInfoAPIResponse>) {
    Object.assign(this, values);
  }

  public deserialize(): Individual {
    const id = Guid.fromJSON(this.individualId);
    const userId = Guid.fromJSON(this.userId);
    const legalEntityId = Guid.fromJSON(this.legalEntityId);
    const firstName = this.firstName;
    const lastName = this.lastName;

    if (!id) {
      throw new Error("Individual ID is required to deserialize MarketplaceSubscriberInfoAPIResponse");
    }
    if (!userId) {
      throw new Error("User ID is required to deserialize MarketplaceSubscriberInfoAPIResponse");
    }
    if (!legalEntityId) {
      throw new Error("Legal Entity ID is required to deserialize MarketplaceSubscriberInfoAPIResponse");
    }
    if (!firstName) {
      throw new Error("First Name is required to deserialize MarketplaceSubscriberInfoAPIResponse");
    }
    if (!lastName) {
      throw new Error("Last Name is required to deserialize MarketplaceSubscriberInfoAPIResponse");
    }

    return Individual.create({
      ...this,
      id,
      userId,
      legalEntityId,
      isVisible: this.isVisible ?? true,
      profile: IndividualProfile.create(
        IndividualProfile.fromJSON({
          ...this,
          userId: userId.value,
          firstName,
          lastName,
          avatarId: this.avatar ? Guid.fromJSON(this.avatar)?.value : undefined,
          email: this.email,
          resumeId: this.resume ? Guid.fromJSON(this.resume)?.value : undefined,
        })
      ),
      company: Company.create({
        id: this.companyId ? new Guid(this.companyId) : Guid.generate(),
        legalEntityId: this.legalEntityId ? new Guid(this.legalEntityId) : Guid.generate(),
        // The server leaves the name out when it may not tell this reader the member's company, and a
        // placeholder in its place reads as a company called "Unknown Company".
        profile: this.companyName
          ? CompanyProfile.create({ name: this.companyName, categories: [] })
          : undefined,
      }),
    });
  }
}
